export default ({ request }) => ({
  ecomAmzReplenishmentListApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentConfirmLogisticsApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/confirmLogistics',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailUpdateApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/update',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailDelApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailApprovedApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/approved',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailRejectedApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/rejected',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentSubmitReplyApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/submitReply',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentConfirmReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/confirmReplenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentCancelReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/cancelReplenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailInvLevelTotalApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/invLevelTotal',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailAppendApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/append',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailStopReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/stopReplenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentConfirmReplyTotalCtnCbmApi(amzReplenishmentCode) {
    return request({
      url: `/ecom/amz/replenishment/confirmReplyTotalCtnCbm/${amzReplenishmentCode}`,
      method: 'GET',
    })
  },
  ecomAmzReplenishmentSubmitReplyTotalCtnCbmApi(amzReplenishmentCode) {
    return request({
      url: `/ecom/amz/replenishment/submitReplyTotalCtnCbm/${amzReplenishmentCode}`,
      method: 'GET',
    })
  },
  ecomAmzReplenishmentDetailListByScmFbaApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/listByScmFba',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailSetScmFbaApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/setScmFba',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyListScmFbaApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/listScmFba',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionListApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionStoreRegionApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/storeRegion',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionDelApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionClearApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/clear',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionClearAllApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/clear/all',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentPromotionDelRowApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/promotion/del/row',
      method: 'POST',
      data,
    })
  },
})
